import { ELEMENT_IMAGE, ELEMENT_MEDIA_EMBED } from '@udecode/plate'
import { createCaptionPlugin } from '@udecode/plate-caption'

export default () =>
  createCaptionPlugin({
    options: { pluginKeys: [ELEMENT_IMAGE, ELEMENT_MEDIA_EMBED] }
  })
